import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import HeaderContent from "./Component/HeaderSection/HeaderContent";
import { routeList } from "./config/routeConfig";
import ScrollToTop from "./Component/ScrollToTop";

function AppRoutes() {
  return (
    <Routes>
      <Route element={<HeaderContent />}>
        {routeList.map(({ path, Component, ...rest }) =>
          Component ? (
            <Route key={path} path={path} element={<Component />} {...rest} />
          ) : (
            <Route key={path} path={path} {...rest} />
          )
        )}
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AppRoutes />
    </Router>
  );
}

export default App;
